var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.076 9.615c1.32 0 2.465-.473 3.4-1.408.934-.935 1.408-2.078 1.408-3.4 0-1.32-.474-2.464-1.409-3.399C12.54.474 11.397 0 10.075 0c-1.32 0-2.464.474-3.398 1.408-.935.935-1.409 2.079-1.409 3.4 0 1.32.474 2.464 1.409 3.399.934.934 2.078 1.408 3.399 1.408zM18.488 15.349a11.875 11.875 0 0 0-.162-1.261 9.937 9.937 0 0 0-.31-1.268 6.264 6.264 0 0 0-.521-1.183 4.463 4.463 0 0 0-.786-1.024 3.466 3.466 0 0 0-1.13-.71 3.903 3.903 0 0 0-1.441-.26c-.204 0-.4.083-.781.33-.235.153-.509.33-.814.525-.262.167-.616.323-1.054.464-.426.138-.86.209-1.288.209-.427 0-.86-.07-1.288-.209-.437-.14-.791-.297-1.053-.464-.302-.193-.577-.37-.814-.525-.38-.247-.578-.331-.781-.331-.52 0-1.004.088-1.442.261a3.463 3.463 0 0 0-1.13.71 4.463 4.463 0 0 0-.785 1.024c-.217.381-.392.78-.521 1.183a9.96 9.96 0 0 0-.31 1.268c-.08.447-.135.872-.162 1.262-.027.381-.04.778-.04 1.178 0 1.042.331 1.886.984 2.508.646.614 1.5.925 2.537.925h9.611c1.038 0 1.892-.311 2.537-.925.653-.622.985-1.465.985-2.508 0-.402-.014-.799-.04-1.179z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.e32f41ca.svg";
export { ForwardRef as ReactComponent };